module.exports = __webpack_public_path__ + "img/banner_xs.b4cef8b3.png";